/**
 * i18n — English (en) ✅ COMPLETE
 */

const en = {
  appTitle: 'Tarkov Money Maker 2',
  modeBadgePvp: 'PvP',
  modeBadgePve: 'PvE',
  modeBadgeSeason: 'Season 1',
  loading: 'Loading',
  filterSearchLabel: 'Search',
  filterSearchPlaceholder: 'Item name, Enter or click…',
  filterSearchAddTerm: 'Add another term…',
  filterSearchAdd: 'add',
  filterProfitLabel: 'Min profit',
  filterLevelLabel: 'Player level',
  filterOffersLabel: 'Min offers',
  filterOffersDisabled: 'API does not provide offer count for this mode. Filter disabled.',
  traderEnable: 'enable',
  traderDisable: 'disable',
  intelNotBuilt: 'Not built',
  intelLevel1: 'Level 1',
  intelLevel2: 'Level 2',
  intelLevel3: '-30% flea fee',
  colItem: 'Item',
  colBuyTrader: 'Buy Trader',
  colSellTrader: 'Sell Trader',
  colAction: 'Action',
  colBestProfit: '★ Best Profit',
  colTraderFlea: 'Trader→Flea',
  colFleaTrader: 'Flea→Trader',
  colFlea: 'Flea',
  copyToast: 'Copied!',
  tooltipBuyPrices: 'Trader buy prices',
  tooltipSellPrices: 'Sell prices',
  flea24h: 'Flea — 24h',
  fleaCur: 'Current',
  fleaLow: 'Low 24h',
  fleaAvg: 'Avg 24h',
  fleaHigh: 'High 24h',
  fleaOffers: 'offers',
  recFTS: 'Buy Flea → Sell Trader',
  recBTF: 'Buy Trader → Sell Flea',
  cardBuy: 'Buy',
  cardSell: 'Sell',
  cardOffers: 'offers',
  paginationOf: 'of',
  paginationPerPage: 'Per page:',
  paginationPage: 'Page',
  paginationTapSort: 'Tap to sort',
  noItems: 'No profitable items found. Lower the threshold or enable more traders.',
  chartTitle: 'Flea — 24h snapshot',
  chartNoData: 'Insufficient data',
  apiStatusTitle: 'Sync Status',
  apiStatusOnline: 'tarkov.dev Online',
  apiStatusDegraded: 'tarkov.dev Degraded',
  apiStatusOffline: 'tarkov.dev Offline',
  apiStatusChecking: 'Checking…',
  apiStatusGlobal: 'Global Status',
  apiStatusLastSync: 'Last sync',
  apiStatusItems: 'Synced items',
  apiStatusItemsSub: 'total cumulated',
  apiStatusSource: 'API Source',
  apiStatusSourceSub: 'auto-check every 30s',
  apiStatusCheckedAt: 'Checked',
  apiStatusModeStatus: 'Status',
  apiStatusModeItems: 'Items',
  apiStatusModeLastSync: 'Last sync',
  apiStatusModeDuration: 'Duration',
  apiStatusNever: 'never',
  apiStatusJustNow: 'just now',
  apiStatusTimeAgoPrefix: '',
  apiStatusMinutesAgo: 'min ago',
  apiStatusHoursAgo: 'h ago',
  apiStatusRest: 'REST',
  exportCSV: 'Export CSV',
  exportJSON: 'Export JSON',
  histFleaPrice: 'Flea price — last 24h',
  histOffers: 'Offers — last 24h',
  histLoading: 'Loading history…',
  histNoData: 'No history yet — data accumulates after each sync.',
  histError: 'Server unreachable — history will be available once the backend is running.',
};

export default en;
